import { Firebase$ } from './firebase$';
import { inject } from '@angular/core';
import { Storage, ref, uploadBytes } from '@angular/fire/storage';
import {
    connectStorageEmulator,
    deleteObject,
    getBlob,
    getDownloadURL,
    getStorage,
} from 'firebase/storage';

export class FirebaseStorage {
    private _storage: Storage;
    private _helpPrefix?: string;

    constructor(private _firebase: Firebase$) {
        this._storage = inject(Storage);
    }

    get coords() {
        return this._firebase.coords;
    }

    async helppath(fn: string) {
        if (this._helpPrefix) {
            return `${this._helpPrefix}${fn.substring(1)}?alt=media`;
        } else {
            const storage = getStorage();
            const fileRef = ref(storage, `help${fn}`);
            const url = await getDownloadURL(fileRef);

            const i = url.indexOf('%2F');
            this._helpPrefix = url.substring(0, i + 3);
            return url;
        }
    }
    async downloadAttachmentFile(rPth: string) {
        const storageRef = ref(this._storage, rPth);
        let blob: any;
        try {
            console.log('GETTING FILE', rPth);
            blob = await getBlob(storageRef);
        } catch (e) {
            return false;
        }
        try {
            // const r = await navigator.storage.getDirectory();
            // let dH = await r.getDirectoryHandle('_attachments', { create: true });
            // const fH = await dH.getFileHandle(rPth.split('/').pop()!, { create: true });
            await this.coords.utils$.writeToDisk(`/_attachments/${rPth.split('/').pop()!}`, blob);
            return true;
        } catch (e) {
            console.log('Download attachment Failed', e);
            return false;
        }
    }

    private async _getRemoteBlob(remotePath: string): Promise<Blob> {
        let blob: any;
        let storageRef;
        try {
            storageRef = ref(this._storage, remotePath);
        } catch (e) {
            console.error('Download BLOB Failed 1', e);
            blob = null;
        }
        if (storageRef) {
            try {
                blob = await getBlob(storageRef!);
            } catch (e: any) {
                if (remotePath.startsWith('help/')) blob = null;
                else {
                    console.error('Download BLOB Failed 2', e);
                    if (e.code === 'storage/object-not-found') {
                        blob = 404;
                        await this.coords.firebase$.firestore.removeStoragePath(remotePath);
                    } else blob = null;
                }
            }
        }
        return blob;
    }

    async downloadZipFile(cloudInfo: any) {
        try {
            const blob = await this._getRemoteBlob(cloudInfo.remotePath);
            // console.log(6666666666, cloudInfo)
            this.coords.manifest$.post('process-zip-file', {
                currentUserId: this.coords.user$.currentId,
                cloudInfo: cloudInfo,
                blob: blob,
            });
            return true;
        } catch (e) {
            console.error('Download ZIP Failed', e);
            return false;
        }
    }

    async downloadFile2(remotePath: string) {
        try {
            const blob = await this._getRemoteBlob(remotePath);
            return blob;
        } catch (e) {
            console.error('Download File Failed', e);
            return null;
        }
    }

    private async _blobUpload(remotePath: string, blob: Blob) {
        const storageRef = ref(this._storage, remotePath);
        try {
            await uploadBytes(storageRef, blob);
            return true;
        } catch (e) {
            console.error('FirebaseStorage uploadFile', remotePath, e);
            return false;
        }
    }

    async uploadBlob(remotePath: string, blob: Blob) {
        const resp = await this._blobUpload(remotePath, blob);
        return resp;
    }

    async uploadFile(remotePath: string, file: File, mimetype?: string) {
        const blob = mimetype ? new Blob([file], { type: 'application/json' }) : file;

        const resp = await this._blobUpload(remotePath, blob);
        return resp;
    }

    async deleteFile(remotePath: string) {
        try {
            const storageRef = ref(this._storage, remotePath);
            await deleteObject(storageRef);
            return true;
        } catch (e) {
            return false;
        }
    }
}
